export default 'fiatBalances'
